import {BREAKPOINTS} from 'utilities/breakpoints';
import {makeImageSourceData} from 'components/UIKit/Picture';

import texingOutdoorsDesktop from './texting-outdoors-desktop.jpg';
import texingOutdoorsDesktop2x from './texting-outdoors-desktop2x.jpg';
import texingOutdoorsTablet from './texting-outdoors-tablet.jpg';
import texingOutdoorsTablet2x from './texting-outdoors-tablet2x.jpg';
import texingOutdoorsMobile from './texting-outdoors-mobile.jpg';
import texingOutdoorsMobile2x from './texting-outdoors-mobile2x.jpg';

export const defaultPictureData = {
  sources: [
    makeImageSourceData(texingOutdoorsMobile, texingOutdoorsMobile2x, BREAKPOINTS.mobile),
    makeImageSourceData(texingOutdoorsTablet, texingOutdoorsTablet2x, BREAKPOINTS.tablet),
    makeImageSourceData(texingOutdoorsDesktop, texingOutdoorsDesktop2x, BREAKPOINTS.desktopUp),
  ],
  fallback: texingOutdoorsTablet2x,
};
